// The report control beside the account menu (ADR-0518 1a): drawn for every
// role on every signed-in page **of a deployment that names a Mayday**
// (`Me.in_app_report`, ADR-0527 4a); one that names none draws nothing. While
// a captured error is unreported it carries a quiet mark: a dot, and an
// accessible name saying so. Nothing else changes, and opening the panel is
// always the person's own click (or a page's error fallback asking, which is
// also the person's click).
import { useEffect, useState, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { Glyph, ReportProblemIcon } from "../icons";
import { useSession } from "../shell/session";
import { listen, OPEN_REPORT, setAvailable, snapshot, subscribe } from "./capture";
import { ReportPanel } from "./ReportPanel";

export function ReportControl({ roleOf }: { roleOf(scope: { orgId?: string; customerId?: string; siteId?: string }): string | undefined }) {
  const { me } = useSession();
  const on = me?.in_app_report === true;
  const noted = useSyncExternalStore(subscribe, () => snapshot().noted);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setAvailable(on);
    if (!on) return;
    const stop = listen();
    const ask = () => setOpen(true);
    window.addEventListener(OPEN_REPORT, ask);
    return () => {
      stop();
      window.removeEventListener(OPEN_REPORT, ask);
      setAvailable(false);
    };
  }, [on]);

  if (!on) return null;
  const label = noted ? "Report a problem — an error was noted on this page" : "Report a problem or ask for something";
  return (
    <>
      <button type="button" className="ws-report" aria-label={label} title={label} aria-haspopup="dialog" onClick={() => setOpen(true)}>
        <Glyph icon={ReportProblemIcon} size={20} />
        {noted && <span className="report-mark" aria-hidden="true" />}
      </button>
      {/* Portalled to the body: the control sits in the rail, and `.nav` is
          sticky, which makes it a stacking context of its own, so a sheet drawn
          inside it was painted under the page's own positioned content (a map
          covered it, measured in Chrome on #2206's branch). */}
      {open && createPortal(<ReportPanel onClose={() => setOpen(false)} roleOf={roleOf} />, document.body)}
    </>
  );
}
